import { call, put, delay } from "redux-saga/effects";
import { ordersApi } from "@services/api";
import {
  getCartActions,
  handleCartActions,
  updateIsActiveCartItemAction,
} from "../slices";

function* handleCartWorker({ payload }) {
  yield delay(300);
  try {
    yield put(handleCartActions.pending());
    const response = yield call(ordersApi.handleCart, payload);
    yield put(handleCartActions.success(response));

    // yield put(getCartActions.pending());
    // const responseGet = yield call(ordersApi.getCart, payload);
    // yield put(getCartActions.success(responseGet));
    yield put(updateIsActiveCartItemAction(payload));
    // TODO: handle callback | onSuccess
  } catch (error) {
    console.log(error);
    yield put(handleCartActions.failure(error));
    yield put(getCartActions.pending());
    const responseGet = yield call(ordersApi.getCart, payload);
    yield put(getCartActions.success(responseGet));
    // TODO: handle callback | onFailure
  }
}

export { handleCartWorker };
